<template>
  <div class="">
    <!-- <transition name="fadein"> -->
      <router-view></router-view>
    <!-- </transition> -->
  </div>
</template>

<script>
export default {

}
</script>

<style lang="postcss" scoped>
.fadein-enter-active, .fadein-leave-active {
  transition: opacity 1.0s;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
}
.fadein-enter, .fadein-leave-to /* .fadein-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
